import { render, staticRenderFns } from "./galeriGorselleri.vue?vue&type=template&id=6b30dd74&scoped=true&"
import script from "./galeriGorselleri.vue?vue&type=script&lang=js&"
export * from "./galeriGorselleri.vue?vue&type=script&lang=js&"
import style0 from "./galeriGorselleri.vue?vue&type=style&index=0&id=6b30dd74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b30dd74",
  null
  
)

export default component.exports